import { memo } from 'react';
import { useSeekableEnd } from './ProgressBarContext.js';
import { ProgressBarClassNames } from './utils.js';
import DotTooltip from './DotTooltip.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';
import '@dtvgo/slider';
import '@dtvgo/tooltip';

/* External */
function SeekableEndDot(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$tooltipBgColor = _ref.tooltipBgColor,
    tooltipBgColor = _ref$tooltipBgColor === void 0 ? 'transparent' : _ref$tooltipBgColor,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/jsx(DotTooltip, {
    className: ProgressBarClassNames.element('seekable-end-dot', className),
    value: useSeekableEnd(),
    placement: placement,
    tooltipBgColor: tooltipBgColor,
    children: children
  });
}
var SeekableEndDot$1 = /*#__PURE__*/memo(SeekableEndDot);

export { SeekableEndDot$1 as default };
//# sourceMappingURL=SeekableEndDot.js.map
